





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import DealListComponent from '@/components/DealListComponent.vue';                       // @ is an alias to /src
import * as utils_tracker from '@/utils_tracker';
import * as utils_topshot from '@/utils_topshot';
import { Deal } from '@/Deal'
import { Challenge } from '@/Challenge'
import { TokenUser } from '@/TokenUser'
import { io, Socket } from "socket.io-client";
import MomentSelectorAndSorterComponent from '@/components/MomentSelectorAndSorterComponent.vue';                       // @ is an alias to /src
import { AdvancedSearch } from '@/Moment' 

let USE_SOCKET_IO: boolean = false
const STOP_AFTER_X_CONSECUTIVE_ERRORS: number = 2

@Component({
  name: 'LiveDeals',
  components: { DealListComponent, MomentSelectorAndSorterComponent }
})

export default class LiveDealsComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public deals: Deal[] = []
  public advancedSearchStringUsed: string = null
  private playerID: number = null
  private setID: number = null
  private playID: number = null

  // UI and filter options
  public minDealRatings: Array<{ label: string, minRating: number }> = [
    { label: 'Show +', minRating: 0.5 },
    { label: '🔥+', minRating: 1 },
    { label: '🔥🔥+', minRating: 2 },
    { label: '🔥🔥🔥+', minRating: 3 },
    { label: '🔥🔥🔥🔥+', minRating: 4 },
    { label: '🔥🔥🔥🔥🔥', minRating: 5 },
  ]
  public minDealRating: { label: string, minRating: number } = this.minDealRatings[1]

  public minLiquidityRatings: Array<{ label: string, minRating: number }> = [
    { label: 'Any 💧', minRating: 0 },
    { label: '💧+', minRating: 1 },
    { label: '💧💧+', minRating: 2 },
    { label: '💧💧💧+', minRating: 3 },
    { label: '💧💧💧💧+', minRating: 4 },
    { label: '💧💧💧💧💧', minRating: 5 },
  ]
  public minLiquidityRating: { label: string, minRating: number } = this.minLiquidityRatings[1]

  public minDealAudios: Array<{ label: string, minRating: number }> = [
    { label: 'Silence', minRating: -1 },
    { label: 'Ding +', minRating: 0.5 },
    { label: 'Ding 🔥+', minRating: 1 },
    { label: 'Ding 🔥🔥+', minRating: 2 },
    { label: 'Ding 🔥🔥🔥+', minRating: 3 },
    { label: 'Ding 🔥🔥🔥🔥+', minRating: 4 },
    { label: 'Ding 🔥🔥🔥🔥🔥', minRating: 5 },
  ]
  public minDealAudio: { label: string, minRating: number } = this.minDealAudios[0]

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public isDapperMode(): boolean { return utils_topshot.getDapperMode(); }

  @Watch('minDealRating')
  public async onChangedMinDealRating(minDealRating: { label: string, minRating: number }) {
    this.minDealRating = minDealRating ? minDealRating : this.minDealRatings[1]
    utils_topshot.setPreferredDealRating(this.minDealRating)
    this.deals = []
    await this.fetchData(false)
    if (this.isConnectedBySocket) {
      // join the appropriate room (server will handle leaving old rooms)
      this.socket.emit('joinDealRoom', `deals${this.minDealRating.minRating}`, this.user && this.user._temp.account ? this.user._temp.account.username : null , this.userId ? this.userId : null )
    }
  }
  @Watch('minLiquidityRating')
  public async onChangedMinLiquidityRating(minLiquidityRating: { label: string, minRating: number }) {
    this.minLiquidityRating = minLiquidityRating ? minLiquidityRating : this.minLiquidityRatings[1]
    utils_topshot.setPreferredDealLiquidity(this.minLiquidityRating)
    this.deals = []
    await this.fetchData(false)
    if (this.isConnectedBySocket) {
      // join the appropriate room (server will handle leaving old rooms)
      this.socket.emit('joinDealRoom', `deals${this.minDealRating.minRating}`, this.user && this.user._temp.account ? this.user._temp.account.username : null , this.userId ? this.userId : null )
    }
  }
  @Watch('minDealAudio')
  public async onChangedMinDealAudio(minDealAudio: { label: string, minRating: number }) {
    this.minDealAudio = minDealAudio ? minDealAudio : this.minDealAudios[0]
    if (this.minDealAudio.minRating > 0 && this.minDealAudio.minRating < this.minDealRating.minRating) {
      this.onChangedMinDealRating(this.minDealRatings[Math.floor(this.minDealAudio.minRating)])
    }
    if (this.minDealAudio.minRating > 0) this.ding()
    utils_topshot.setPreferredDealAudio(this.minDealAudio)
  }
  // @Watch('league')
  // public async onLeagueChanged(league: string) {
  //   this.league = league ? league : this.leagues[0]
  //   utils_topshot.setPreferredDealLeague(this.league)
  //   this.deals = []
  //   await this.fetchData(false)
  //   if (this.isConnectedBySocket) {
  //     // join the appropriate room (server will handle leaving old rooms)
  //     this.socket.emit('joinDealRoom', `deals${this.minDealRating.minRating}`, this.user && this.user._temp.account ? this.user._temp.account.username : null , this.userId ? this.userId : null )
  //   }
  // }

  public async onChangedPSD(player: { label: string, playerID: number }, set: { label: string, setID: number }, duo: { label: string, setID: number, playID: number }) {
    this.playerID = player.playerID
    this.setID = duo.setID || set.setID

    if (!this.playID && duo.playID) {
      this.playID = duo.playID
    } else {
       this.playID = duo.playID
    }

    this.deals = []
    await this.fetchData(false)
  }  

  public async onChangedAdvanced(advancedSearch: AdvancedSearch) {
    if (advancedSearch) this.advancedSearchStringUsed = JSON.stringify(advancedSearch)
    else this.advancedSearchStringUsed = null

    this.deals = []
    await this.fetchData(false)
  }  

  public ding() {
    if (this.dingSound) this.dingSound.play();
  }

  // March 14, 2024: for now, don't show flowty deals unless in dapper admin mode (!dapperon)
  // March 19, 2024 1:15pm - set to true to release flowty deals!
  public showFlowty(): boolean {
    return true
    return this.isDapperMode()
  }
  public showDeal(deal: Deal): boolean  {
    if (!deal.flowtyListingResourceID) return true
    return (this.showFlowty())
  }

  // private, non-reactive member variables
  private lastFetchSucceeded: boolean = true
  private timerFetch
  private timerUpdateTimeAgo
  private numErrorsInARow: number = 0
  private socket: Socket = null
  private numConnectionErrors: number = 0
  private isConnectedBySocket: boolean
  private dingSound: HTMLAudioElement
  private isFetching: boolean = false

  private startTimeAgoUpdateTimer() {
    this.timerUpdateTimeAgo = setInterval(function() {
      this.deals.forEach((d) => d.setListedAgo())
    }.bind(this), 1000)
  }

  private stopTimeAgoUpdateTimer() {
    if (this.timerUpdateTimeAgo) clearTimeout(this.timerUpdateTimeAgo)
    this.timerUpdateTimeAgo = null
  }

  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`LiveDeals.pathChanged() ${this.$route.path}`)

    if (!USE_SOCKET_IO) await this.fetchData(false)
  }

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    // partial rollout to people based on their unique clientid
    const ucid: number = utils.getAndSetUniqueClientID()
    // USE_SOCKET_IO = utils_topshot.getBubbaMode() || utils_topshot.getFastPolling() || ucid % 5 === 0     // 5% at first => 10% => 20%
    USE_SOCKET_IO = true    // try going for 100%

    // restore your favorite deal settings
    const savedMinDealLiquidity: { label: string, minRating: number } = utils_topshot.getPreferredDealLiquidity()
    if (savedMinDealLiquidity != null) this.minLiquidityRating = savedMinDealLiquidity
    const savedMinDealRating: { label: string, minRating: number } = utils_topshot.getPreferredDealRating()
    if (savedMinDealRating != null) this.minDealRating = savedMinDealRating
    const savedMinAudioRating: { label: string, minRating: number } = utils_topshot.getPreferredDealAudio()
    if (savedMinAudioRating != null) this.minDealAudio = savedMinAudioRating
    // const league: string = utils_topshot.getPreferredDealLeague()
    // if (league != null) this.league = league


    await this.pathChanged()

    // if we end up connecting by socket, then don't do the fetch
    this.timerFetch = setInterval(function() {
      if (this.isConnectedBySocket) return
      if (this.lastFetchSucceeded || this.numErrorsInARow < STOP_AFTER_X_CONSECUTIVE_ERRORS) {
        this.fetchData(true)
      }
    }.bind(this), 3000)

    if (USE_SOCKET_IO) this.connectSocket()

    if (new Date() < new Date('04-04-2021')) utils.showTopAlert('warning', 'New Feature: Each deal now shows a "Liquidity Index," which is a representation of the volume of recent sales for that moment, taking into account its serial #. More💧 droplets indicate higher liquidity.', null)
    if (new Date() < new Date('08-15-2021')) utils.showTopAlert('success', "Good news: We've lowered the collector score requirements for participating in LiveToken Auctions. You now need 1000 CS to post and 250 CS to bid.", null)

    this.dingSound = new Audio('/sounds/ding.mp3')

  }
  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)

    if (this.timerFetch) clearTimeout(this.timerFetch)
    this.timerFetch = null

    this.stopTimeAgoUpdateTimer()

    if (this.socket && this.isConnectedBySocket) {
      this.socket.emit('leaveRoom', `deals${this.minDealRating.minRating}`, this.user && this.user._temp.account ? this.user._temp.account.username : null, this.userId ? this.userId : null )
      this.socket.disconnect()
    }
    this.socket = null
  }

  // https://socket.io/docs/v4/client-socket-instance/
  private connectSocket() {
    try {
      // https://socket.io/docs/v3/using-multiple-nodes/
      this.socket = io(utils.getURLprefix(), { autoConnect: true, transports: [ "websocket" ] });   // it was very important to not allow polling 

      // for debugging
      if (this.$store.state.devmode) {
        this.socket.onAny((event, ...args) => {
          console.log(event, args);
        });
      }

      // handle a new deal coming in
      this.socket.on("newDeal", (po: object) => {
        const deal: Deal = new Deal(po)

        let passesFilters: boolean = true

        // filter by PSD
        if (this.playerID && deal.playerID !== this.playerID) passesFilters = false
        if (this.setID && deal.setID !== this.setID) passesFilters = false
        if (this.playID && deal.playID !== this.playID) passesFilters = false

        // filter by advanced search
        if (this.advancedSearchStringUsed) {
          const advSearch: AdvancedSearch = JSON.parse(this.advancedSearchStringUsed)

          if (advSearch.league === 'NBA' && deal.getTeamAbbreviation().startsWith('W-')) passesFilters = false
          if (advSearch.league === 'WNBA' && !deal.getTeamAbbreviation().startsWith('W-')) passesFilters = false

          if (advSearch.team && advSearch.team !== deal.team) passesFilters = false
          if (advSearch.playCategory && advSearch.playCategory !== deal.playCategory) passesFilters = false
          if (advSearch.minPrice && deal.price < advSearch.minPrice) passesFilters = false
          if (advSearch.maxPrice && deal.price > advSearch.maxPrice) passesFilters = false
          if (advSearch.minFMV && deal.valueFMV < advSearch.minFMV) passesFilters = false
          if (advSearch.maxFMV && deal.valueFMV > advSearch.maxFMV) passesFilters = false
          if (advSearch.minSerial && deal.serialNumber < advSearch.minSerial) passesFilters = false
          if (advSearch.maxSerial && deal.serialNumber > advSearch.maxSerial) passesFilters = false
          const discountPercentage =  (deal.valueFMV - deal.price) / deal.valueFMV
          if (advSearch.minDiscount && discountPercentage < advSearch.minDiscount) passesFilters = false
          if (advSearch.jersey && !deal.isJerseyNumber) passesFilters = false
          if (advSearch.lastMint && !deal.isMaxSerial) passesFilters = false
          if (advSearch.neverSold && deal.numTimesSold > 0) passesFilters = false
          if (advSearch.tsdebut && !deal.isFirstMoment) passesFilters = false
          if (advSearch.rookieYear && !deal.isRookieMoment) passesFilters = false
          if (advSearch.rookieMint && !deal.isRookieMint) passesFilters = false
          if (advSearch.rookiePremiere && !deal.isRookieDebut) passesFilters = false
          if (advSearch.champYear && !deal.isChampionshipYear) passesFilters = false
          if (advSearch.challengeReward && !deal.isChallengeReward) passesFilters = false
          if (advSearch.craftingChallengeReward && !deal.isCraftingChallengeReward) passesFilters = false
          if (advSearch.rarity && deal.setVisualId !== utils_topshot.convertRarityToSetVisualId(advSearch.rarity)) passesFilters = false
          if (advSearch.series !== null && advSearch.series !== undefined && deal.series !== advSearch.series) passesFilters = false      // May 16, 2024

        }

        if (passesFilters && (deal.liquidityRating >= this.minLiquidityRating.minRating || deal.auction)) {
          if (deal.dealRating >= this.minDealRating.minRating) this.deals.splice(1, 0, deal)
          if (this.deals.length > 200) this.deals.length = 200
          if (this.minDealAudio.minRating > 0 && deal.dealRating >= this.minDealAudio.minRating) this.ding()
        }
      });
      // handle a deal going gone
      this.socket.on("dealGone", (po: object) => {
        const deal: Deal = new Deal(po)
        for (const existingDeal of this.deals) {
          if (deal.momentID === existingDeal.momentID && deal.seller === existingDeal.seller) {
            existingDeal.gone = true
            existingDeal.goneInSec = deal.goneInSec
            break
          }
        }
      });

      // This event is fired by the Socket instance upon connection and reconnection
      this.socket.on("connect", async () => {
        if (this.$store.state.devmode) console.log(`${new Date().toLocaleString()}: Socket ${this.socket.id} connected`)
        await this.fetchData(false)
        if (this.socket) {
          this.isConnectedBySocket = true
          this.socket.emit('joinDealRoom', `deals${this.minDealRating.minRating}`, this.user && this.user._temp.account ? this.user._temp.account.username : null , this.userId ? this.userId : null )
        }
      });
      this.socket.on("connect_error", async () => {
        this.numConnectionErrors++
        if (this.$store.state.devmode) console.log(`${new Date().toLocaleString()}: Socket ${this.socket.id} got connect_error. Waiting ${this.numConnectionErrors}s before attempting reconnect`)
        await utils.sleep(this.numConnectionErrors * 1000)
        this.isConnectedBySocket = false
        if (this.socket) this.socket.connect();
      });
      this.socket.on("disconnect", (reason: string) => {
        this.isConnectedBySocket = false

        // not sure why every so often we get - "Socket undefined disconnected with reason: transport close"
        if (this.$store.state.devmode) console.log(`${new Date().toLocaleString()}: Socket ${this.socket.id} disconnected with reason: ${reason}`)

        if (reason === "io server disconnect") {
          // the disconnection was initiated by the server, so you need to reconnect manually (other forms of disconnect will auto reconnect)
          // if (this.$store.state.devmode || utils_topshot.getBubbaMode()) console.log(`${new Date().toLocaleString()}: Atempting manual reconnect because reason was ${reason}`)
          if (this.socket) this.socket.connect();
        }

      });

    } catch (e) {

    }


  }

  private async fetchData(autoFetch: boolean): Promise<void> {
    if (autoFetch && this.isFetching) return 

    const fakeMoment: Deal = new Deal(null)
    fakeMoment.momentID = 0
    fakeMoment.valueFMV = 0

    this.lastFetchSucceeded = false

    if (!autoFetch) this.$store.commit('setLoading', { loading: true });
    this.isFetching = true
    try {
      this.stopTimeAgoUpdateTimer()

      let url: string = utils.getURLprefix() + `/api/topshot/deals?autoFetch=${autoFetch}`
      url += `&minDealRating=${this.minDealRating.minRating}`
      url += `&minLiquidityRating=${this.minLiquidityRating.minRating}`
      // if (utils_topshot.getFastPolling()) url += `&fp=true`
      // if (utils_topshot.getBubbaMode()) url += `&bm=true`
      if (!utils_topshot.getChallenges()) url += `&sc=true`
      if (this.socket && this.isConnectedBySocket) url += `&socketId=${this.socket.id}`     // not sure server really cares, but oh well

      // March 22, 2022
      if (this.playerID) url += `&playerID=${this.playerID}`
      if (this.setID) url += `&setID=${this.setID}`
      if (this.playID) url += `&playID=${this.playID}`
      if (this.advancedSearchStringUsed) url += `&advancedSearch=${encodeURIComponent(this.advancedSearchStringUsed)}`

      const response: any = await utils.makeGetCall(url);

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        this.isFetching = false
        return;
      }

      // error check
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });
        this.numErrorsInARow++
        if (this.numErrorsInARow >= STOP_AFTER_X_CONSECUTIVE_ERRORS) utils.toast(this, 'Error', response.data.error)
        this.isFetching = false
        return
      }

      // challenges
      if (response.data.challenges) utils_topshot.setChallenges(response.data.challenges.map((po) => new Challenge(po)))
      if (response.data.expiredChallenges) utils_topshot.setExpiredChallenges(response.data.expiredChallenges.map((po) => new Challenge(po)))

      // moments
      if (response.data.deals) {
        this.deals = [ fakeMoment ].concat(response.data.deals.map((d) => new Deal(d)))
        // this.deals = this.deals.filter((d) => !d.auction)   // June 18, 2021 - temporarily ignore anything with deal.auction during auction testing
        this.deals.forEach((d) => d.setListedAgo())
        this.startTimeAgoUpdateTimer()
      }

      // for now, filter by liquidity here on the client side, but TODO is to have server possibly do it
      //  server now does it
      // this.deals = this.deals.filter((d) => d.momentID === 0 || d.liquidityRating >= this.minLiquidityRating.minRating)

      this.lastFetchSucceeded = true
      this.numErrorsInARow = 0

    } catch (error) {
      if (this.$store.state.devmode) console.log(error);
      this.numErrorsInARow++
      if (this.numErrorsInARow >= STOP_AFTER_X_CONSECUTIVE_ERRORS) if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
    }

    this.$store.commit("setLoading", { loading: false });
    this.isFetching = false

  }  
}
